module.exports = __webpack_public_path__ + "img/screener-card.f24b0c36.svg";